import { render, staticRenderFns } from "./ratepropertytab.vue?vue&type=template&id=3f38643d"
import script from "./ratepropertytab.vue?vue&type=script&lang=js"
export * from "./ratepropertytab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports